import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type LawyerDocumentsAsLawyerQueryVariables = Types.Exact<{ [key: string]: never }>

export type LawyerDocumentsAsLawyerQuery = {
  __typename?: 'Query'
  lawyerDocumentsAsLawyer: Array<{
    __typename?: 'LawyerDocument'
    fileFormat?: string | null
    fileUrl: string
    id: number
    name: string
  }>
}

export const LawyerDocumentsAsLawyerDocument = gql`
  query LawyerDocumentsAsLawyer {
    lawyerDocumentsAsLawyer {
      fileFormat
      fileUrl
      id
      name
    }
  }
`
export function useLawyerDocumentsAsLawyerQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LawyerDocumentsAsLawyerQuery,
    LawyerDocumentsAsLawyerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LawyerDocumentsAsLawyerQuery,
    LawyerDocumentsAsLawyerQueryVariables
  >(LawyerDocumentsAsLawyerDocument, options)
}
export function useLawyerDocumentsAsLawyerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LawyerDocumentsAsLawyerQuery,
    LawyerDocumentsAsLawyerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LawyerDocumentsAsLawyerQuery,
    LawyerDocumentsAsLawyerQueryVariables
  >(LawyerDocumentsAsLawyerDocument, options)
}
export type LawyerDocumentsAsLawyerQueryHookResult = ReturnType<
  typeof useLawyerDocumentsAsLawyerQuery
>
export type LawyerDocumentsAsLawyerLazyQueryHookResult = ReturnType<
  typeof useLawyerDocumentsAsLawyerLazyQuery
>
export type LawyerDocumentsAsLawyerQueryResult = ApolloReactCommon.QueryResult<
  LawyerDocumentsAsLawyerQuery,
  LawyerDocumentsAsLawyerQueryVariables
>
export function refetchLawyerDocumentsAsLawyerQuery(
  variables?: LawyerDocumentsAsLawyerQueryVariables
) {
  return { query: LawyerDocumentsAsLawyerDocument, variables: variables }
}
